import { render, staticRenderFns } from "./WashServicePrice.vue?vue&type=template&id=0039c0dd&scoped=true"
import script from "./WashServicePrice.vue?vue&type=script&lang=js"
export * from "./WashServicePrice.vue?vue&type=script&lang=js"
import style0 from "./WashServicePrice.vue?vue&type=style&index=0&id=0039c0dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0039c0dd",
  null
  
)

export default component.exports